<template>
	<QaLayout>
		<QaItem1/>
	</QaLayout>
</template>

<script>
import QaItem1 from './qaItem1.vue';
import QaLayout from './qaLayout.vue';
export default {
	components: {
		QaLayout,
		QaItem1
	}
}
</script>